var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[(this.$store.state.isLoading)?_c('Loading'):_vm._e(),(this.$store.state.isAlertDialog)?_c('AlertDialog'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }